import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6cc214e9")

_pushScopeId("data-v-6cc214e9")
const _hoisted_1 = { class: "container popup-container" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "profile-title" }
const _hoisted_4 = { class: "profile-content" }
const _hoisted_5 = { class: "profile-block" }
const _hoisted_6 = { class: "profile-block-title" }
const _hoisted_7 = { class: "profile-block-data" }
const _hoisted_8 = { class: "profile-data-name" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_10 = { class: "profile-block" }
const _hoisted_11 = { class: "profile-block-title" }
const _hoisted_12 = { class: "profile-block-data" }
const _hoisted_13 = { class: "check-item" }
const _hoisted_14 = {
  class: "cbx w-100",
  for: "BoViewProviders",
  tabindex: "12"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_16 = { class: "checkboxtext col-10" }
const _hoisted_17 = { class: "check-item" }
const _hoisted_18 = {
  class: "cbx w-100",
  for: "BoEditProviders",
  tabindex: "12"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_20 = { class: "checkboxtext col-10" }
const _hoisted_21 = { class: "check-item" }
const _hoisted_22 = {
  class: "cbx w-100",
  for: "BoCreateProviders",
  tabindex: "12"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_24 = { class: "checkboxtext col-10" }
const _hoisted_25 = { class: "profile-block" }
const _hoisted_26 = { class: "profile-block-title" }
const _hoisted_27 = { class: "profile-block-data" }
const _hoisted_28 = { class: "check-item" }
const _hoisted_29 = {
  class: "cbx w-100",
  for: "ViewOrders",
  tabindex: "12"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_31 = { class: "checkboxtext col-10" }
const _hoisted_32 = { class: "check-item" }
const _hoisted_33 = {
  class: "cbx w-100",
  for: "ChangeOrderStatus",
  tabindex: "12"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_35 = { class: "checkboxtext col-10" }
const _hoisted_36 = { class: "profile-block" }
const _hoisted_37 = { class: "profile-block-title" }
const _hoisted_38 = { class: "profile-block-data" }
const _hoisted_39 = { class: "check-item" }
const _hoisted_40 = {
  class: "cbx w-100",
  for: "ProductsViewSearch",
  tabindex: "12"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_42 = { class: "checkboxtext col-10" }
const _hoisted_43 = { class: "check-item" }
const _hoisted_44 = {
  class: "cbx w-100",
  for: "EditProducts",
  tabindex: "12"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_46 = { class: "checkboxtext col-10" }
const _hoisted_47 = { class: "profile-block" }
const _hoisted_48 = { class: "profile-block-title" }
const _hoisted_49 = { class: "profile-block-data" }
const _hoisted_50 = { class: "check-item" }
const _hoisted_51 = {
  class: "cbx w-100",
  for: "DocumentViewSearch",
  tabindex: "12"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_53 = { class: "checkboxtext col-10" }
const _hoisted_54 = { class: "check-item" }
const _hoisted_55 = {
  class: "cbx w-100",
  for: "DocumentShare",
  tabindex: "12"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_57 = { class: "checkboxtext col-10" }
const _hoisted_58 = { class: "profile-block" }
const _hoisted_59 = { class: "profile-block-title" }
const _hoisted_60 = { class: "profile-block-data" }
const _hoisted_61 = { class: "check-item" }
const _hoisted_62 = {
  class: "cbx w-100",
  for: "BoSettingsView",
  tabindex: "12"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_64 = { class: "checkboxtext col-10" }
const _hoisted_65 = { class: "check-item" }
const _hoisted_66 = {
  class: "cbx w-100",
  for: "BoTagsEditCreateDelete",
  tabindex: "12"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_68 = { class: "checkboxtext col-10" }
const _hoisted_69 = { class: "check-item" }
const _hoisted_70 = {
  class: "cbx w-100",
  for: "BoCitiesEditCreateDelete",
  tabindex: "12"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_72 = { class: "checkboxtext col-10" }
const _hoisted_73 = { class: "check-item" }
const _hoisted_74 = {
  class: "cbx w-100",
  for: "BoCurrencyEditCreateDelete",
  tabindex: "12"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_76 = { class: "checkboxtext col-10" }
const _hoisted_77 = { class: "check-item" }
const _hoisted_78 = {
  class: "cbx w-100",
  for: "BoUsersEditCreateDelete",
  tabindex: "12"
}
const _hoisted_79 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_80 = { class: "checkboxtext col-10" }
const _hoisted_81 = { class: "check-item" }
const _hoisted_82 = {
  class: "cbx w-100",
  for: "BoProfilesEditCreateDelete",
  tabindex: "12"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "col-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_84 = { class: "checkboxtext col-10" }
const _hoisted_85 = { class: "profile-edit-footer" }
const _hoisted_86 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20 d-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.id > 0 ? _ctx.$t('provider.edit-profile') : _ctx.$t('provider.create-profile')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('provider.profile-name')), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, [
              _createVNode("span", null, _toDisplayString(_ctx.$t('provider.profile-name')), 1),
              _hoisted_9
            ]),
            _withDirectives(_createVNode("input", {
              class: "profile-data-name-input",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.profile.description = $event))
            }, null, 512), [
              [_vModelText, _ctx.profile.description]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('title.providers')), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoViewProviders",
                value: _ctx.permissions.BoViewProviders,
                id: "BoViewProviders",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_14, [
                _hoisted_15,
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('permission.bo-providers-view')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoEditProviders",
                value: _ctx.permissions.BoEditProviders,
                id: "BoEditProviders",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_18, [
                _hoisted_19,
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('permission.bo-providers-edit')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoCreateProviders",
                value: _ctx.permissions.BoCreateProviders,
                id: "BoCreateProviders",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_22, [
                _hoisted_23,
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('permission.bo-providers-create')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('title.orders')), 1),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "ViewOrders",
                value: _ctx.permissions.ViewOrders,
                id: "ViewOrders",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_29, [
                _hoisted_30,
                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('permission.view-orders')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "ChangeOrderStatus",
                value: _ctx.permissions.ChangeOrderStatus,
                id: "ChangeOrderStatus",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_33, [
                _hoisted_34,
                _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('permission.change-order-status')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('title.products')), 1),
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "ProductsViewSearch",
                value: _ctx.permissions.ProductsViewSearch,
                id: "ProductsViewSearch",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_40, [
                _hoisted_41,
                _createVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('permission.view-products')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "EditProducts",
                value: _ctx.permissions.EditProducts,
                id: "EditProducts",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_44, [
                _hoisted_45,
                _createVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('permission.edit-products')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_47, [
          _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('title.document')), 1),
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "DocumentViewSearch",
                value: _ctx.permissions.DocumentViewSearch,
                id: "DocumentViewSearch",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_51, [
                _hoisted_52,
                _createVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('permission.document-view-search')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "DocumentShare",
                value: _ctx.permissions.DocumentShare,
                id: "DocumentShare",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_55, [
                _hoisted_56,
                _createVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('permission.document-share')), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_58, [
          _createVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('title.settings')), 1),
          _createVNode("div", _hoisted_60, [
            _createVNode("div", _hoisted_61, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoSettingsView",
                value: _ctx.permissions.BoSettingsView,
                id: "BoSettingsView",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_62, [
                _hoisted_63,
                _createVNode("span", _hoisted_64, _toDisplayString(_ctx.$t('permission.setings-view')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoTagsEditCreateDelete",
                value: _ctx.permissions.BoTagsEditCreateDelete,
                id: "BoTagsEditCreateDelete",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_66, [
                _hoisted_67,
                _createVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('permission.tags-edit-create-delete')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_69, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoCitiesEditCreateDelete",
                value: _ctx.permissions.BoCitiesEditCreateDelete,
                id: "BoCitiesEditCreateDelete",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_70, [
                _hoisted_71,
                _createVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('permission.cities-edit-create-delete')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_73, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoCurrencyEditCreateDelete",
                value: _ctx.permissions.BoCurrencyEditCreateDelete,
                id: "BoCurrencyEditCreateDelete",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_74, [
                _hoisted_75,
                _createVNode("span", _hoisted_76, _toDisplayString(_ctx.$t('permission.currency-edit-create-delete')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_77, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoUsersEditCreateDelete",
                value: _ctx.permissions.BoUsersEditCreateDelete,
                id: "BoUsersEditCreateDelete",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_78, [
                _hoisted_79,
                _createVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('permission.user-edit-create-delete')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_81, [
              _withDirectives(_createVNode("input", {
                class: "inp-cbx",
                name: "BoProfilesEditCreateDelete",
                value: _ctx.permissions.BoProfilesEditCreateDelete,
                id: "BoProfilesEditCreateDelete",
                type: "checkbox",
                style: {"display":"none"},
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.profile.permissions = $event))
              }, null, 8, ["value"]), [
                [_vModelCheckbox, _ctx.profile.permissions]
              ]),
              _createVNode("label", _hoisted_82, [
                _hoisted_83,
                _createVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('permission.profile-edit-create-delete')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_85, [
        _createVNode("button", {
          class: "cancel",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cancel()))
        }, _toDisplayString(_ctx.$t('button.cancel')), 1),
        _createVNode("button", {
          class: "save",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.save()))
        }, [
          _hoisted_86,
          _createTextVNode(_toDisplayString(_ctx.$t('button.save')), 1)
        ])
      ])
    ])
  ]))
})